/**
 * Fields returned from account-franchise-audit-trail Lambda
 */
export interface IAuditLogEntry {
  eventId: string;
  accountId: string;
  franchiseName: string;
  actionType: string;
  modifiedDate: string;
  modifiedBy: string;
}

/**
 * Normalizes API date strings that use a space separator instead of 'T'
 * e.g. "2026-04-07 12:00:00.000" → "2026-04-07T12:00:00.000"
 */
export const normalizeApiDate = (date: string): string =>
  date.includes(" ") ? date.replace(" ", "T") : date;
